<div class="payload-viewer" *ngIf="payload || asciiString">

    <div class="payload-buttons u-grid">
        <div class="u-col" *ngIf="showDecodeOptionsToggle">
            <p-selectButton [multiple]="true"
                            [options]="decodeOptions"
                            [(ngModel)]="selectedDecodeOption"
                            (onChange)="toggleDecodeOption()">
            </p-selectButton>
        </div>
        <div *ngIf="showDecoderOptions && showAscii && decoderOptions.length > 0" class="decoder-options u-col">
            Options:
            <p-selectButton [multiple]="true"
                            [options]="decoderOptions"
                            [(ngModel)]="selectedDecoderOption"
                            (onChange)="toggleDecoder()">
            </p-selectButton>
        </div>
    </div>
    <div class="payloads">

        <div class="payload hex" *ngIf="showHex" [ngClass]="{'payload-50': (showAscii && showHex), 'payload-100': !(showAscii && showHex), 'full-height': fullHeight}">
            <code class="hex-line" style="padding-right: 10px; width: auto;"> {{ hexLineNumbers }} </code>
            <code
                class="hex-content" #hex
                [irHighlightTextComp]="transformedAscii"
                [irHexMode]="true"
                [hexString]="hexString"
                [irHighlightTextOptions]="hightlightOptions"
                [irDisplayHex]="(showAscii && showHex)? 'sync' : 'show' "
                [irQuickSearchItems]="quickSearchItems"
                (irLineNumbers)="generateHexLineNumbers($event)"
                (irSelectionPosition)="ascii.highlightSelection($event)">
            </code>
        </div>

        <div class="payload ascii" *ngIf="showAscii" [ngClass]="{'payload-50': (showAscii && showHex), 'payload-100': !(showAscii && showHex)}">
            <code
                class="ascii-content" #ascii
                [irHighlightTextOptions]="hightlightOptions"
                [irHighlightTextComp]="transformedAscii"
                [irRemoveNonPrintable]="true"
                [irDisplayHex]="(showAscii && showHex)? 'sync' : 'show' "
                [irQuickSearchItems]="quickSearchItems"
                (irSelectionPosition)="hex.highlightSelection($event)">
            </code>
        </div>

    </div>
    <div class="u-grid copy-buttons">
        <div class="u-col hex">
            <div class="u-grid u-justify-end">
                <button pButton class="primaryAction" type="button" icon="pi pi-copy" label="Copy HEX" (click)="copyToClipboard()"></button>
            </div>
        </div>
        <div class="u-col">
            <div class="u-grid u-justify-end">
                <button pButton class="primaryAction" type="button" icon="pi pi-copy" label="Copy ASCII" (click)="copyToClipboard('ascii')"></button>
            </div>
        </div>
    </div>
</div>
